import type {
	API_GetCustomerRiskAnalysisResponse,
	CustomerRiskAnalysisResponseData,
} from "@pilatestime/shared-types";
import { queryOptions } from "@tanstack/react-query";
import api from "./api_client";

export const fetchOrgMgmtCustomerRiskAnalysis = (
	token: string,
	organizationId: string,
	windowDays: number,
	minCancellations: number,
): Promise<CustomerRiskAnalysisResponseData> =>
	api
		.get(
			`/organizations/${organizationId}/org-management/customer-risk-analysis?windowDays=${windowDays}&minCancellations=${minCancellations}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		)
		.then((res) => {
			const response = res.data as API_GetCustomerRiskAnalysisResponse;
			return response.data;
		});

export const fetchOrgMgmtCustomerRiskAnalysisQueryOptions = (
	organizationId: string,
	token: string,
	windowDays: number,
	minCancellations: number,
) =>
	queryOptions({
		queryKey: [
			"org_mgmt_customer_risk_analysis",
			organizationId,
			windowDays,
			minCancellations,
		],
		queryFn: () =>
			fetchOrgMgmtCustomerRiskAnalysis(
				token,
				organizationId,
				windowDays,
				minCancellations,
			),
		staleTime: 5 * 60 * 1000,
		gcTime: 10 * 60 * 1000,
		retry: 2,
		retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
	});
